import { render, staticRenderFns } from "./videoTab.vue?vue&type=template&id=7ed7ee32&scoped=true&"
import script from "./videoTab.ts?vue&type=script&lang=js&"
export * from "./videoTab.ts?vue&type=script&lang=js&"
import style0 from "./videoTab.vue?vue&type=style&index=0&id=7ed7ee32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed7ee32",
  null
  
)

export default component.exports